<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '../cn'

  /**
   * A commercial vessel (container ship) — distinct from {@link IconPortcall}
   * (lucide `Ship`), which is reused for the port-call concept. Drawn in the
   * lucide stroke style (24×24, stroke-width 2, round caps) so it sits flush
   * beside the re-exported lucide icons.
   */
  const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    :class="cn('size-5', props.class)"
  >
    <!-- hull -->
    <path d="M3 13h18l-2 6H5z" />
    <!-- container stacks on deck -->
    <path d="M7 13V8h3.5v5" />
    <path d="M12.5 13V6h4v7" />
    <!-- waterline -->
    <path
      d="M2 22c1.5 0 1.5-1 3-1s1.5 1 3 1 1.5-1 3-1 1.5 1 3 1 1.5-1 3-1 1.5 1 3 1"
    />
  </svg>
</template>
